
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment-gateway/pricing-packages",
      function () {
        return require("private-next-pages/payment-gateway/pricing-packages/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment-gateway/pricing-packages"])
      });
    }
  